import { render, staticRenderFns } from "./marketingComponents.vue?vue&type=template&id=9f1b295a&scoped=true&lang=pug&"
import script from "./marketingComponents.vue?vue&type=script&lang=js&"
export * from "./marketingComponents.vue?vue&type=script&lang=js&"
import style0 from "./marketingComponents.vue?vue&type=style&index=0&id=9f1b295a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f1b295a",
  null
  
)

export default component.exports